import { useMemo } from "react";
import parseGatheringIdentifier from "src/helpers/parseGatheringIdentifier";

const useParseGatheringIdentifier = (identifier: string) => {
	const result = useMemo<
		{ gatheringId: string; refCode?: never } | { refCode: string; gatheringId?: never }
	>(() => {
		return parseGatheringIdentifier(identifier);
	}, [identifier]);
	return result;
};
export default useParseGatheringIdentifier;
